
import React, { ReactNode } from 'react';
import { PageBackground } from './page-background';
import { cn } from '@/lib/utils';

interface PageContainerProps {
  children: ReactNode;
  title?: string;
  variant?: 'default' | 'ai' | 'pregnancy' | 'professional';
  intensity?: 'low' | 'medium' | 'high';
  className?: string;
  animateBackground?: boolean;
  centered?: boolean;
  fullWidth?: boolean;
}

export const PageContainer: React.FC<PageContainerProps> = ({
  children,
  title,
  variant = 'default',
  intensity = 'medium',
  className = '',
  animateBackground = true,
  centered = false,
  fullWidth = false
}) => {
  return (
    <>
      <PageBackground 
        variant={variant} 
        intensity={intensity} 
        animate={animateBackground}
      />
      
      <main className={cn(
        "relative z-10 min-h-[calc(100vh-200px)]",
        !fullWidth && "container mx-auto max-w-7xl",
        centered && "flex flex-col items-center justify-center",
        "py-8 px-4 md:px-6 w-full",
        className
      )}>
        {title && (
          <div className="mb-6 animate-fade-in w-full">
            <h1 className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-primary to-blue-600 bg-clip-text text-transparent">
              {title}
            </h1>
          </div>
        )}
        
        <div className="animate-fade-in w-full" style={{ animationDelay: "0.1s" }}>
          {children}
        </div>
      </main>
    </>
  );
};
